/* eslint-disable camelcase */
/* eslint-disable indent */
import { call, put, takeEvery } from 'redux-saga/effects';

import { actions } from '../../utils/constants';

import {
    fetchExportPerfomedTests,
    fetchPerfomedTests,
    getCorrectionTest,
    getApprovesTest,
    fetchUserEad,
    fetchCenters,
    discardTest,
} from '../../utils/common-functions';

function getSerializedPerformedTests({ users, performedTests, centers = [] }) {
    const serializedPerformedTests = performedTests.map(performedTest => {
        const user = users.find(user => user.id === performedTest.user_id);
        const center = centers.find(
            findCenter => findCenter.id === performedTest.center_id,
        );
        return {
            ...performedTest,
            center,
            user: user
                ? {
                      email: user.email,
                      nickname: user.nickname,
                  }
                : {},
        };
    });

    return serializedPerformedTests;
}

function* asyncFetchPerformedTests({
    payload: { status = [], search='', page=0, limit=25, center_id=undefined },
}) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const params = {};
        if (status.length > 0) {
            Object.assign(params, { status });
        }
        if (center_id) {
            Object.assign(params, { center_id: center_id });
        }
        if (page !== undefined) {
            Object.assign(params, { page: page });
        }
        if (limit) {
            Object.assign(params, {
                page_size: limit,
            });
        }

        let serializedPerformedTests = [],
            totalPerformedTest = 0,
            centers = [];
        if (search && search.trim()) {
            const responseUsers = yield call(fetchUserEad, {
                params: {
                    ...params,
                    order: 'email',
                    order_mode: 'asc',
                    search: search,
                },
            });
            const users = responseUsers.data.users;

            if (users.length > 0) {
                const userIds = users.map(user => user.id);
                const responseCenters = yield call(fetchCenters);
                centers = responseCenters.data;
                const response = yield call(fetchPerfomedTests, {
                    params: { ...params, user_id: userIds },
                });
                const performedTests = response.data.performed_tests;

                serializedPerformedTests = getSerializedPerformedTests({
                    performedTests,
                    users,
                    centers,
                });

                totalPerformedTest = response.data.total;
            }
        } else {
            const responseCenters = yield call(fetchCenters);
            centers = responseCenters.data;
            const response = yield call(fetchPerfomedTests, { params });
            const performedTests = response.data.performed_tests;

            const userIds = [];
            if (performedTests.length > 0) {
                performedTests.map(performedTest => {
                    if (!userIds.includes(performedTest.user_id)) {
                        userIds.push(performedTest.user_id);
                    }
                });
                const responseUsers = yield call(fetchUserEad, {
                    params: {
                        mode: 'full',
                        userId: userIds,
                    },
                });
                const users = responseUsers.data.users;

                serializedPerformedTests = getSerializedPerformedTests({
                    performedTests,
                    users,
                    centers,
                });

                totalPerformedTest = response.data.total;
            }
        }

        yield put({
            type: actions.CHANGE_PERFORMED_TESTS,
            payload: {
                performed_tests: serializedPerformedTests,
                total: totalPerformedTest,
                centers,
            },
        });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: 'Não foi possível listar testes realizados',
            },
        });
    }
}

function* asyncExportTestConducted({ payload }) {
    const { status, center_id } = payload;
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const params = {};
        if (status && status.length > 0) {
            Object.assign(params, { status });
        }
        if (center_id) {
            Object.assign(params, { center_id: center_id });
        }

        const response = yield call(fetchExportPerfomedTests, params);

        const performedTestsToCSV = response.data;

        let contentCsv = 'data:text/csv;charset=utf-8,' + performedTestsToCSV;

        const encodedUri = encodeURI(contentCsv);
        yield put({
            type: actions.CHANGE_CONTENT_CSV_TO_EXPORT_PERFORMED_TESTS,
            payload: encodedUri,
        });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Não foi possível realizar a busca por núcleos. Tente novamente',
            },
        });
    }
}

function* approvesTest({ payload }){
    try {

        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const { testId, currentFilters  } = payload;

        yield call(getApprovesTest, testId);

        yield asyncFetchPerformedTests({ payload: { ...currentFilters} });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });

    } catch(err){
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Não foi possível realizar a aprovação do teste. Tente novamente',
            },
        });
    }
}

function* _discardTest({ payload }){
    try {

        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const { testId, currentFilters  } = payload;

        yield call(discardTest, testId);

        yield asyncFetchPerformedTests({ payload: { ...currentFilters} });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });

    } catch(err){
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Não foi possível remover teste. Tente novamente',
            },
        });
    }
}

function* correctionTest({ payload }){
    try {

        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const { testId, currentFilters  } = payload;

        yield call(getCorrectionTest, testId);

        yield asyncFetchPerformedTests({ payload: { ...currentFilters} });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });

    } catch(err){
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Não foi possível realizar a aprovação do teste. Tente novamente',
            },
        });
    }
}


export default function* testsConducted() {
    yield takeEvery(
        actions.ASYNC_FETCH_PERFORMED_TESTS,
        asyncFetchPerformedTests,
    );
    yield takeEvery(
        actions.ASYNC_EXPORT_PERFORMED_TESTS,
        asyncExportTestConducted,
    );
    yield takeEvery(
        actions.ASYNC_APPROVES_TEST,
        approvesTest
    );
    yield takeEvery(
        actions.ASYNC_CORRECTION_TEST,
        correctionTest
    );
    yield takeEvery(
        actions.ASYNC_DISCARD_TEST,
        _discardTest
    );
}



// WEBPACK FOOTER //
// ./src/components/tests-conducted/tests-conducted.saga.js